module.exports = __webpack_public_path__ + "static/media/porvoo_55km.0e2e1a68.jpeg";